import React from 'react';
import { Modal } from 'react-responsive-modal';
import { useForm } from "react-hook-form";
import useToast from 'hooks/useToast';
import * as Yup from 'yup';
import { yupResolver } from '@hookform/resolvers/yup';

const AddPromoCodePopup = (props) => {
    const { open, close, campaignDetailID, mountedRef, addPromoCode } = props;
    const toast = useToast();

    const promoCodeForm = useForm({ resolver: yupResolver(Yup.object().shape({
        code: Yup.string()
                .max(200, 'Code must be no more than 200 characters')
                .required("Code is required")
    })) });

    const promoCodeFormSubmitHandler = (frmData) => {
        if (addPromoCode.isLoading) return;
        addPromoCode.mutateAsync({ id: campaignDetailID, code: frmData.code })
            .then(() => promoCodeForm.reset())
            .catch(err => toast.error("Failed to add promo code", err))
            .finally(() => { if (mountedRef.current) close(); });
    };

    return (
        <Modal classNames={{ overlay: 'add-promo-code-overlay', modal: 'add-promo-code-modal' }} open={open} onClose={close} center>
            <div className="add-promo-code">
                <h3>Add promo code</h3>
                <form onSubmit={promoCodeForm.handleSubmit(promoCodeFormSubmitHandler)}>
                    <div className="link-field">
                        <input type="text"
                            placeholder='enter your promo code...'
                            {...promoCodeForm.register("code")}
                        />
                        <p className="btn grey"><input type="submit" value="Add" disabled={addPromoCode.isLoading} /></p>
                    </div>
                    {promoCodeForm.formState.errors?.code?.message && <span className="error-msg" style={{display: 'block'}}>{promoCodeForm.formState.errors?.code?.message}</span>}
                </form>
                <div className='promo-code-info'>
                    <p className='note'><em>Note: promo codes are valid for 30 days from creation</em></p>
                </div>
            </div>
        </Modal>
    );
};

export default AddPromoCodePopup;
